import { render } from "./QuiSommesNouss.vue?vue&type=template&id=ec2b6586&scoped=true&ts=true"
import script from "./QuiSommesNouss.vue?vue&type=script&lang=ts"
export * from "./QuiSommesNouss.vue?vue&type=script&lang=ts"

import "./QuiSommesNouss.vue?vue&type=style&index=0&id=ec2b6586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2b6586"]])

export default __exports__